// AuthContext.js
import React, { createContext, useContext, useState } from "react";

// Create context
const AuthContext = createContext();

// Custom hook to use the auth context
export const useAuth = () => useContext(AuthContext);

// Provider component
export const AuthProvider = ({ children }) => {
  // const [mobileNumber, setMobileNumber] = useState();
  // const [countryCode, setCountryCode] = useState("995");
  // const [smsId, setSmsId] = useState("");
  // const [isRegOtp, setIsRegOtp] = useState(false);

  return (
    <AuthContext.Provider
      value={
        {
          // mobileNumber,
          // setMobileNumber,
          // countryCode,
          // setCountryCode,
          // smsId,
          // setSmsId,
          // isRegOtp,
          // setIsRegOtp,
        }
      }
    >
      {children}
    </AuthContext.Provider>
  );
};
